<template>
  <div>
  <section id="Redeem">
    <div class="row">
      <div
        class="title col-md-8 d-none d-lg-flex align-items-center justify-content-start ml-auto"
      >
        <h1 class="h5">HS超集點生活圈，圈住你的每一天</h1>
      </div>
      <div class="col-12 mt-25">
        <div class="card w-100 border-0 rounded-0">
          <div class="card-body p-0">
            <div class="row">
              <div class="card-left col-lg-4">
                <div class="d-flex align-items-start justify-content-center">
                  <img
                    src="@/assets/image/redeem_card.png"
                    alt="redeem card"
                    class="d-flex align-items-center justify-content-center"
                  />
                </div>
              </div>
              <div class="card-right col-lg-8">
                <img
                  src="@/assets/image/redeem_header.png"
                  alt="redeem header"
                  class="d-flex redeem-header align-items-center justify-content-center"
                />
                <div class="desc">
                 <p class="promo-description">
                            嗨比幫你準備好序號啦！<br>
                            輸入電話號碼後，直接點擊領取一起開箱你的幸運點數！
                        </p>
                 <form id="redemption-form" @submit.prevent="submitForm">
                        <div class="input-group">
                            <label for="promo_code">活動序號</label>
                            <div class="input-wrapper">
                              <input type="text" id="promo_code" name="promo_code" v-model="form.promo_code" @input="clearPromoCodeError" @blur="handlePromoCodeBlur" placeholder="請輸入兌換碼" required>
                              <p v-if="promoCodeError" class="input-error">{{ promoCodeError }}</p>
                            </div>
                        </div>
                        <div class="input-group">
                            <label for="phone_number">行動電話</label>
                            <div class="input-wrapper">
                              <input type="tel" id="phone_number" name="phone_number" v-model="form.phone_number" @input="clearPhoneNumberError" @blur="validatePhoneNumber" placeholder="請輸入手機號碼" pattern="[0-9]{10}" required>
                              <p v-if="phoneNumberError" class="input-error">{{ phoneNumberError }}</p>
                            </div>
                        </div>
                    </form>
                 <div class="notice-area">
                        <h3 class="notice-title">注意事項</h3>
                        <ol class="notice-list">
                            <li>點數將隨機發放，每組序號限領一次。</li>
                            <li>點數價值1點=1元，跨通路適用漢來大飯店、漢神百貨、漢來美食。</li>
                            <li>完成兌換後，點數將立即自動匯入您的HS超集點會員帳號，請至H'S VIBE APP查詢。</li>
                            <li>請確認手機號碼正確無誤，填寫錯誤可能導致點數無法正常被兌換，恕無法補發。</li>
                            <li>凡參與本活動，即視同接受本活動注意事項及相關規定，本公司保有隨時修正、暫停或終止本活動之權利，若有未盡事宜，悉依本公司之相關公告辦理，本公司保留最終解釋及決定權利。</li>
                            <li>若有其他相關問題，敬請聯絡客服電話 <span class="phone-link">02-8979-5558</span></li>
                        </ol>
                  </div>
                    <button type="submit" form="redemption-form" class="submit-button">點我兌換</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 彈窗 -->
  <div ref="modalPortal">
  <transition name="modal-fade">
    <div v-if="modal.show" class="modal-overlay" @click.self="modal.show = false">
      <div class="modal-box">
        <div class="modal-header">
          {{ modal.type === 'success' ? '兌換成功' : '兌換失敗' }}
        </div>
        <div class="modal-body">
          <p class="modal-message" :class="modal.type === 'success' ? 'modal-message--success' : 'modal-message--error'">{{ modal.message }}</p>
          <button class="modal-close-btn" @click="modal.show = false">確認</button>
        </div>
        <img src="@/assets/image/campaign_modal_icon.png" alt="" class="modal-side-icon" />
      </div>
    </div>
  </transition>
  </div>
  </div>
</template>

<script>
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MOBILE_REGEX = /^09\d{8}$/;

export default {
  name: 'Redeem',
  metaInfo: {
    title: '兌換活動 | ',
  },
  data() {
    return {
      eventId: null,
      eventVerified: false,
      promoCodeError: '',
      phoneNumberError: '',
      modal: {
        show: false,
        type: 'success',
        message: '',
      },
      form: {
        promo_code: '',
        phone_number: '',
      },
    };
  },
  mounted() {
    document.body.appendChild(this.$refs.modalPortal);
  },
  beforeDestroy() {
    if (this.$refs.modalPortal && document.body.contains(this.$refs.modalPortal)) {
      document.body.removeChild(this.$refs.modalPortal);
    }
  },
  created() {
    this.getPromoCodeFromRoute();
    this.verifyCode();
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.getPromoCodeFromRoute();
        this.verifyCode();
      },
    },
  },
  methods: {
    showModal(type, message) {
      this.modal.type = type;
      this.modal.message = message;
      this.modal.show = true;
    },
    getPromoCodeFromRoute() {
      this.eventId = this.$route.query.event_id || null;
      this.form.promo_code = this.$route.query.code || '';
    },
    clearPromoCodeError() {
      this.promoCodeError = '';
      this.eventVerified = false;
    },
    clearPhoneNumberError() {
      this.phoneNumberError = '';
    },
    handlePromoCodeBlur() {
      if (!this.validatePromoCodeFormat()) {
        return;
      }
      this.verifyCode();
    },
    validatePromoCodeFormat() {
      if (!this.form.promo_code) {
        this.promoCodeError = '請輸入活動序號';
        this.eventVerified = false;
        return false;
      }

      if (!UUID_REGEX.test(this.form.promo_code)) {
        this.promoCodeError = '兌換碼格式驗證失敗';
        this.eventVerified = false;
        return false;
      }

      this.promoCodeError = '';
      return true;
    },
    validatePhoneNumber() {
      if (!this.form.phone_number) {
        this.phoneNumberError = '請輸入手機號碼';
        return false;
      }

      if (!MOBILE_REGEX.test(this.form.phone_number)) {
        this.phoneNumberError = '請輸入正確的手機號碼格式（例：0912345678）';
        return false;
      }

      this.phoneNumberError = '';
      return true;
    },
    verifyCode() {
      const { eventId } = this;
      const { promo_code: code } = this.form;

      if (!eventId || !UUID_REGEX.test(eventId) || !code || !UUID_REGEX.test(code)) {
        this.eventVerified = false;
        this.promoCodeError = '兌換碼格式驗證失敗';
        return;
      }

      this.axios
        .get(`/event/${eventId}/code/${code}`)
        .then(() => {
          this.promoCodeError = '';
          this.eventVerified = true;
        })
        .catch((error) => {
          this.eventVerified = false;
          this.promoCodeError = error.response?.data?.message || '兌換碼格式驗證失敗';
        });
    },
    submitForm() {
      this.promoCodeError = '';
      this.phoneNumberError = '';

      if (!this.validatePromoCodeFormat()) {
        return;
      }

      if (!this.eventId || !UUID_REGEX.test(this.eventId)) {
        this.promoCodeError = '兌換碼格式驗證失敗';
        this.eventVerified = false;
        return;
      }

      if (!this.eventVerified) {
        this.promoCodeError = this.promoCodeError || '兌換碼格式驗證失敗';
        return;
      }

      if (!this.validatePhoneNumber()) {
        return;
      }
      const payload = {
        code: this.form.promo_code,
        mobile: this.form.phone_number,
      };
      this.axios
        .post(`event/${this.eventId}/redemptions`, payload)
        .then((response) => {
          const msg = (response?.data.message || '兌換成功！點數將會發放至您的帳號').replace(/，/g, '\n');
          this.showModal('success', msg);
        })
        .catch((error) => {
          this.showModal('error', error.response?.data?.message || '兌換失敗，請稍後再試');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#Redeem {
  overflow: hidden;
  padding: 0px 0 100px;
  .title {
    border-bottom: 2px solid $primary-light;
  }
  img.redeem-header {
    height:80px;
    width:auto;
    margin:20px auto;
    @media (min-width: 992px) {
       margin:40px 0px;
    }
  }
  .card {
    .card-body {
      border-radius: 20px;
      background-image: url('../../assets/image/campaign_bg_01.jpg');
      background-size: 150% 150%;;
      background-repeat: no-repeat;
      background-position: center;
      .card-right {
        padding:0 40px;
        @media (min-width: 766px) {
           padding-right:60px;
        }
      }
      .card-left {
        @media (min-width: 992px) {
           padding-right:100px;
        }
        & > div { //這裏指的是浮動的卡片
          height: 200px;
          @media (min-width: 992px) {
            height: 100%;
            background-image: url('../../assets/image/campaign_bg_02.jpg');
            background-size: 150% 120%;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 20px 0 0 20px;
          }
        }
        img {
          position: relative;
          height: 250px;
          width: auto;
          left: 0px;
          top: 0px;
          @media (min-width: 992px) {
            height: 200px;
            left: 80px;
            top: 80px;
          }
          @media (min-width: 1200px) {
            height: 250px;
          }
        }
      }
      .desc {
        padding-bottom:40px;
        p {
          margin-bottom: 15px;
        }
      }
      /* 表單設定 */
      .redemption-form {
          margin-top: 40px;
      }
      .input-group {
          display: flex;
          align-items: center;
          margin: 25px 0px;
      }
      .input-group label {
          flex: 0 0 70px; /* 固定標籤寬度 */
          font-size: 16px;
          font-weight: bold;
          color: var(--text-color-primary);
          margin-right: 5px;
          @media (min-width: 766px) {
             margin-right: 20px;
             flex: 0 0 80px; /* 固定標籤寬度 */
          }
      }
      .input-group input {
          flex: 1;
          padding: 12px 20px;
          font-size: 16px;
          border: 1px solid var(--accent-color-border);
          border-radius: 25px; /* 圓角輸入框 */
          background-color: white;
          transition: border-color 0.2s;
          width:100%;
          max-width:400px;
      }
      .input-group input:focus {
          outline: none;
          border-color: var(--accent-color-logo);
          box-shadow: 0 0 5px rgba(98,106,195,0.3);
      }
      .input-wrapper {
        flex: 1;
        height:60px;
      }
      .input-error {
        margin: 6px 0 0 20px;
        color: #dc3545;
        font-size: 13px;
        line-height: 1.4;
      }
      /* 注意事項 */
      .notice-area {
          width: 100%;
          max-width: 600px;
          padding: 40px 0px;
          border-radius: 10px;
      }
      .notice-title {
          font-size: 14px;
          font-weight: 300;
          width: fit-content;
          padding: 5px 20px;
          background-color: #fff;
          color: var(--text-color-primary);
          margin-bottom: 12px;
          border-radius: 20px;
      }
      .notice-list {
          list-style: decimal inside; /* 內部數字列表 */
          font-size: 14px;
          color: var(--text-color-secondary);
          line-height: 1.6;
      }
      .notice-list li {
          margin-bottom: 8px;
          text-indent: -1em; /* 使第二行文字縮進 */
          padding-left: 1em; /* 與 text-indent 對應 */
      }
      .notice-list li:last-child {
          margin-bottom: 0;
      }
      .phone-link {
          color: var(--accent-color-logo); /* 電話號碼使用 Logo 顏色 */
          font-weight: bold;
      }
      /* 兌換按鈕 */
      .submit-button {
          display: block;
          margin: 0 auto;
          background-color: var(--accent-color-button);
          color: white;
          border: none;
          padding: 10px 40px;
          font-size: 18px;
          border-radius: 30px;
          letter-spacing: 1px;
          cursor: pointer;
          transition: background-color 0.2s, transform 0.1s;
          align-self: center; /* 按鈕置中 */
          background-color: #7b73a8;
          @media (min-width: 992px) {
               margin: 0 auto 0 30%;
          }
      }
      .submit-button:hover {
          background-color: #857db0; /* 懸停時顏色加深 */
      }
      .submit-button:active {
          transform: scale(0.98); /* 點擊時縮小效果 */
      }
    }
  }
}

/* 彈窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-box {
  position: relative;
  background: #fff;
  border-radius: 16px;
  width: 85%;
  max-width: 400px;
  overflow: visible;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}
.modal-side-icon {
  position: absolute;
  left: -25px;
  bottom: -30px;
  width: 110px;
  height: auto;
  pointer-events: none;
  @media (min-width: 766px) {
       width: 130px;
      left: -40px;
  }
}
.modal-header {
  display: block;
  text-align: center;
  letter-spacing: 5px;
  padding: 16px 40px;
  border-radius: 16px 16px 0 0;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  background-color: #857db0;
}
.modal-body {
  padding: 24px 40px;
  text-align: center;
}
.modal-message {
  font-size: 16px;
  margin: 10px 0 30px 0;
  padding: 0 20px;
  white-space: pre-line;
  line-height: 1.5;
  &.modal-message--success { color: #333; }
  &.modal-message--error { color: #dc3545; }
}
.modal-close-btn {
  background-color: #7b73a8;
  color: #fff;
  border: none;
  padding: 10px 40px;
  font-size: 15px;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover { background-color: #857db0; }
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
